"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingBeginEnum = void 0;
var MeetingBeginEnum;
(function (MeetingBeginEnum) {
  /** Тип не определён (быстрый митинг) */
  MeetingBeginEnum[MeetingBeginEnum["not_defined"] = 0] = "not_defined";
  /**
   * Начать конференцию прямо сейчас
   *
   * @see Meeting.duration
   */
  MeetingBeginEnum[MeetingBeginEnum["immediate_time"] = 1] = "immediate_time";
  /**
   * Начать конференцию в указанное время
   *
   * @see Meeting.begin_at
   * @see Meeting.end_at
   */
  MeetingBeginEnum[MeetingBeginEnum["specified_time"] = 2] = "specified_time";
})(MeetingBeginEnum = exports.MeetingBeginEnum || (exports.MeetingBeginEnum = {}));
